// extracted by mini-css-extract-plugin
export default {"container":"module_container__qZYuQ","prev":"module_prev__sTw4w","next":"module_next__DFdKi","module":"module_module__9if2A","module3":"module_module3__DPU-Q"};